import React from 'react'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { List } from 'immutable'
import isFunction from 'lodash/isFunction'
import {
  PLAYLIST_TYPE_DEFAULT,
  PLAYLIST_TYPE_FAVORITES,
} from '../../services/playlist/index'
import IconV2, { ICON_TYPES, ICON_STYLES } from '../Icon.v2/index'
import Button, { TYPES } from '../Button/index'
import { H1 } from '../Heading/index'

const MyLibraryPlaylistHeader = (props) => {
  const {
    staticText,
    pageState = {},
    onEditClick,
    onDeleteClick,
    onRenameClick,
    onShareClick,
    itemsList = List(),
    editMode,
  } = props

  const isUserPlaylist = ![PLAYLIST_TYPE_DEFAULT, PLAYLIST_TYPE_FAVORITES].includes(pageState.type)

  return (
    <header className="my-library__playlist-header">
      <H1>{pageState.name}</H1>
      <div className="my-library__playlist-header-buttons">
        {isFunction(onShareClick) && isUserPlaylist
          && <Button type={TYPES.GHOST} onClick={onShareClick} disabled={editMode}>
            <span className="my-library__playlist-header-button-text">
              {staticText.get('shareButtonText')}
            </span>
            <IconV2 type={ICON_TYPES.SHARE} style={ICON_STYLES.TEAL_CIRCLE}/>
          </Button>
        }
        {isFunction(onDeleteClick) && isUserPlaylist
          && <Button type={TYPES.GHOST} onClick={onDeleteClick} disabled={editMode}>
            <span className="my-library__playlist-header-button-text">
              {staticText.get('deleteButtonText')}
            </span>
            <IconV2 type={ICON_TYPES.DELETE} style={ICON_STYLES.TEAL_CIRCLE}/>
          </Button>
        }
        {isFunction(onRenameClick) && isUserPlaylist
          && <Button type={TYPES.GHOST} onClick={onRenameClick} disabled={editMode}>
            <span className="my-library__playlist-header-button-text">
              {staticText.get('renameButtonText')}
            </span>
            <IconV2 type={ICON_TYPES.RENAME} style={ICON_STYLES.TEAL_CIRCLE}/>
          </Button>
        }
        {isFunction(onEditClick) && itemsList.size > 0
          && <Button type={TYPES.GHOST} onClick={onEditClick}>
            <span className="my-library__playlist-header-button-text">
              {editMode ? staticText.get('saveButtonText') : staticText.get('editButtonText')}
            </span>
            <IconV2
              type={editMode ? ICON_TYPES.CIRCULAR_CHECK : ICON_TYPES.PENCIL}
              style={editMode ? ICON_STYLES.OUTLINE : ICON_STYLES.TEAL_CIRCLE}
            />
          </Button>
        }
      </div>
    </header>
  )
}

MyLibraryPlaylistHeader.propTypes = {
  staticText: ImmutablePropTypes.map.isRequired,
  pageState: PropTypes.object.isRequired,
  onEditClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
  onRenameClick: PropTypes.func,
  onShareClick: PropTypes.func,
  itemsList: ImmutablePropTypes.list,
  editMode: PropTypes.bool,
}

export default MyLibraryPlaylistHeader
